import React, { useState, useEffect, useCallback } from 'react';
import { auditoriaAPI } from '../services/api';
import { APP_VERSION } from '../version';
import { toast } from 'react-toastify';
import { useZonaHoraria } from '../context/ZonaHorariaContext';
import AuditoriaWhatsapp from '../components/AuditoriaWhatsapp';
import AuditoriaNovedades from '../components/AuditoriaNovedades';
import './Auditoria.css';

const Auditoria = () => {
  const { formatFechaHora } = useZonaHoraria();
  const [vista, setVista] = useState('actividad');

  const [registros, setRegistros] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(true);
  const [modulos, setModulos] = useState([]);
  const [filtros, setFiltros] = useState({
    usuario_id: '',
    modulo: '',
    accion: '',
    desde: '',
    hasta: '',
    limit: 100,
    offset: 0,
  });

  const [versionActual, setVersionActual] = useState(APP_VERSION);

  useEffect(() => {
    loadModulos();
  }, []);

  const loadRegistros = useCallback(async () => {
    try {
      setLoading(true);
      const params = { limit: filtros.limit, offset: filtros.offset };
      if (filtros.usuario_id) params.usuario_id = filtros.usuario_id;
      if (filtros.modulo) params.modulo = filtros.modulo;
      if (filtros.accion) params.accion = filtros.accion;
      if (filtros.desde) params.desde = filtros.desde;
      if (filtros.hasta) params.hasta = filtros.hasta;
      const res = await auditoriaAPI.getAll(params);
      if (res.success) {
        setRegistros(res.data);
        setTotal(res.total != null ? res.total : res.data.length);
      }
    } catch (error) {
      toast.error('Error al cargar auditoría');
      setRegistros([]);
    } finally {
      setLoading(false);
    }
  }, [filtros]);

  useEffect(() => {
    if (vista === 'actividad') loadRegistros();
  }, [vista, loadRegistros]);

  const loadModulos = async () => {
    try {
      const res = await auditoriaAPI.getModulos();
      if (res.success && res.data) setModulos(res.data);
    } catch (e) {
      console.error('Error al cargar módulos', e);
    }
  };

  const handleFiltro = (campo, valor) => {
    setFiltros((prev) => ({ ...prev, [campo]: valor, offset: 0 }));
  };

  const formatFecha = (f) => {
    if (!f) return '-';
    return formatFechaHora(f);
  };

  const paginas = Math.ceil(total / (filtros.limit || 1));
  const paginaActual = Math.floor(filtros.offset / filtros.limit) + 1;

  return (
    <div className="auditoria-page pagina-listado pagina-listado--scroll">
      <div className="page-header">
        <h1>Auditoría</h1>
        <p className="auditoria-subtitle">Versión en ejecución: <strong>{versionActual}</strong></p>
      </div>

      <div className="auditoria-tabs" role="tablist">
        <button
          type="button"
          role="tab"
          className={vista === 'actividad' ? 'active' : ''}
          onClick={() => setVista('actividad')}
        >
          Registro de actividad
        </button>
        <button
          type="button"
          role="tab"
          className={vista === 'whatsapp' ? 'active' : ''}
          onClick={() => setVista('whatsapp')}
        >
          Mensajes WhatsApp
        </button>
        <button
          type="button"
          role="tab"
          className={vista === 'versiones' ? 'active' : ''}
          onClick={() => setVista('versiones')}
        >
          Novedades
        </button>
      </div>

      {vista === 'actividad' && (
        <div className="auditoria-actividad-panel">
          <div className="auditoria-filtros">
            <div className="filtro-group">
              <label>Módulo</label>
              <select
                value={filtros.modulo}
                onChange={(e) => handleFiltro('modulo', e.target.value)}
              >
                <option value="">Todos</option>
                {modulos.map((m) => (
                  <option key={m} value={m}>{m}</option>
                ))}
              </select>
            </div>
            <div className="filtro-group">
              <label>Acción</label>
              <input
                type="text"
                placeholder="ej. crear, editar"
                value={filtros.accion}
                onChange={(e) => handleFiltro('accion', e.target.value)}
              />
            </div>
            <div className="filtro-group">
              <label>Desde</label>
              <input
                type="datetime-local"
                value={filtros.desde}
                onChange={(e) => handleFiltro('desde', e.target.value)}
              />
            </div>
            <div className="filtro-group">
              <label>Hasta</label>
              <input
                type="datetime-local"
                value={filtros.hasta}
                onChange={(e) => handleFiltro('hasta', e.target.value)}
              />
            </div>
            <div className="filtro-group">
              <label>Usuario ID</label>
              <input
                type="number"
                placeholder="ID"
                value={filtros.usuario_id}
                onChange={(e) => handleFiltro('usuario_id', e.target.value)}
              />
            </div>
            <button type="button" className="btn-secondary" onClick={loadRegistros}>
              Actualizar
            </button>
          </div>

          {loading ? (
            <div className="loading">Cargando...</div>
          ) : (
            <div className="listado-resultado-panel">
              <div className="listado-tabla-area clientes-listado-tabla-area">
                <div className="table-container">
                <table className="data-table">
                  <thead>
                    <tr>
                      <th>Fecha</th>
                      <th>Usuario</th>
                      <th>Módulo</th>
                      <th>Acción</th>
                      <th>Detalle</th>
                      <th>IP</th>
                    </tr>
                  </thead>
                  <tbody>
                    {registros.length === 0 ? (
                      <tr>
                        <td colSpan="6" className="no-data">No hay registros</td>
                      </tr>
                    ) : (
                      registros.map((r) => (
                        <tr key={r.id}>
                          <td>{formatFecha(r.created_at)}</td>
                          <td>{r.usuario_nombre ? `${r.usuario_nombre} (${r.usuario_username})` : '-'}</td>
                          <td>{r.modulo}</td>
                          <td>{r.accion}</td>
                          <td className="detalle-cell">{r.detalle || '-'}</td>
                          <td>{r.ip || '-'}</td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
              </div>
              {total > filtros.limit && (
                <div className="paginacion">
                  <button
                    type="button"
                    className="btn-secondary"
                    disabled={filtros.offset === 0}
                    onClick={() => setFiltros((prev) => ({ ...prev, offset: Math.max(0, prev.offset - prev.limit) }))}
                  >
                    Anterior
                  </button>
                  <span>Página {paginaActual} de {paginas} ({total} registros)</span>
                  <button
                    type="button"
                    className="btn-secondary"
                    disabled={filtros.offset + filtros.limit >= total}
                    onClick={() => setFiltros((prev) => ({ ...prev, offset: prev.offset + prev.limit }))}
                  >
                    Siguiente
                  </button>
                </div>
              )}
            </div>
          )}
        </div>
      )}

      {vista === 'whatsapp' && <AuditoriaWhatsapp />}

      {vista === 'versiones' && <AuditoriaNovedades onVersionActual={setVersionActual} />}
    </div>
  );
};

export default Auditoria;
